import type { Message, PermissionRequest, QuestionRequest, Session, SessionStatus } from "@openanalyst-ai/sdk/v2/client"
import { sessionPermissionRequest, sessionQuestionRequest } from "../session/composer/session-request-tree"

export type ThreadStatusStore = {
  session: Session[]
  permission: Record<string, PermissionRequest[] | undefined>
  question: Record<string, QuestionRequest[] | undefined>
  message: Record<string, Message[] | undefined>
  session_status: Record<string, SessionStatus | undefined>
}

export function threadHasFeedbackRequest(
  store: Pick<ThreadStatusStore, "session" | "permission" | "question">,
  sessionID: string,
  includePermission: (item: PermissionRequest) => boolean = () => true,
) {
  return (
    !!sessionPermissionRequest(store.session, store.permission, sessionID, includePermission) ||
    !!sessionQuestionRequest(store.session, store.question, sessionID)
  )
}

export function threadIsWorking(
  store: Pick<ThreadStatusStore, "message" | "session_status">,
  sessionID: string,
) {
  const messages = store.message[sessionID] ?? []
  const latestMessage = messages.at(-1)
  const latestMessageAborted = latestMessage?.role === "assistant" && latestMessage.error?.name === "MessageAbortedError"
  const pending = messages.findLast((message) => {
    if (message.role !== "assistant") return false
    if (message.error?.name === "MessageAbortedError") return false
    return typeof message.time?.completed !== "number"
  })
  const status = store.session_status[sessionID]
  if (status?.type === "idle") return false
  if (status?.type === "busy") return !latestMessageAborted
  if (status?.type === "retry") return true
  return pending !== undefined
}

export function threadIsActive(
  store: ThreadStatusStore,
  sessionID: string,
  includePermission?: (item: PermissionRequest) => boolean,
) {
  if (threadHasFeedbackRequest(store, sessionID, includePermission)) return false
  return threadIsWorking(store, sessionID)
}
